var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83335 6.33329H6.33335V6.83329V11C6.33335 11.1821 6.18221 11.3333 6.00002 11.3333C5.81783 11.3333 5.66669 11.1821 5.66669 11V6.83329V6.33329H5.16669H1.00002C0.817829 6.33329 0.666687 6.18215 0.666687 5.99996C0.666687 5.81777 0.817829 5.66663 1.00002 5.66663H5.16669H5.66669V5.16663V0.999959C5.66669 0.817768 5.81783 0.666626 6.00002 0.666626C6.18221 0.666626 6.33335 0.817768 6.33335 0.999959V5.16663V5.66663H6.83335H11C11.1822 5.66663 11.3334 5.81777 11.3334 5.99996C11.3334 6.18215 11.1822 6.33329 11 6.33329H6.83335Z",
    fill: "#323232",
    stroke: "#2B8C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGreen);
export default __webpack_public_path__ + "static/media/add_green.5fa35d9fb1cc4c71bba0bbd652f0ddfe.svg";
export { ForwardRef as ReactComponent };